export const COLORS = {
  TABLE_HEADER: "text-[#2b5631]",
  BACKGROUND: "bg-[#2b5631]",
} as const;
